"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const theme_1 = require("@zapier/theme");
const core_1 = require("@emotion/core");
const API_IMAGES = {
    AppTesterAPI: "url('https://cdn.zapier.com/storage/services/4401a6c0fdab0b69893ab957f2712b81.png')",
    BranchingAPI: "url('https://cdn.zapier.com/storage/services/137baf61724ea2c64812417382bddd1d.128x128.png')",
    CapsuleCRMAPI: "url('https://cdn.zapier.com/storage/services/1029d32eb05260b4a52ba6eebf5dc20f.png')",
    EventbriteAPI: "url('https://cdn.zapier.com/storage/photos/4b2b5f32f92c80fc304ab369be1da347.png')",
    EventbriteDevAPI: "url('https://cdn.zapier.com/storage/developer/638ebef07f1e312e20ee45ddb7df6be5.png')",
    GoogleContactsV2API: "url('https://cdn.zapier.com/storage/services/1508661b55cd3c5ad1787303b0f58c99.png')",
    GoogleSheetsAPI: "url('https://cdn.zapier.com/storage/services/e37713ab22d82f777575279db97cd805.128x128.png')",
    MailChimpAPI: "url('https://cdn.zapier.com/storage/services/5c727288d9c2f69a9eee136c5f5a0f72.128x128.png')",
    OneNoteDevAPI: "url('https://cdn.zapier.com/storage/developer/e951e0105790e43b117e04b7bba34601.png')",
    PivotalTrackerAPI: "url('https://cdn.zapier.com/storage/services/84172dde558de382873cf72a00c92818.128x128.png')",
    QuickBaseAPI: "url('https://cdn.zapier.com/storage/services/3d348ba36ddb1a656e434ccbb984e3c6.png')",
    SkyDriveAPI: "url('https://cdn.zapier.com/storage/services/e67867e9f6f5c089e243dad54467ad33.128x128.png')",
    SurveyMonkeyAPI: "url('https://cdn.zapier.com/storage/services/39b027caffb7fad05f73ed80d664a246.128x128.png')",
    TypeformDevAPI: "url('https://cdn.zapier.com/storage/developer/6df0e2a9ca7350c7407f0d9c2b0709c0.png')",
    ZapierInternalAPI: "url('https://cdn.zapier.com/storage/photos/ff7409c6a52dc217fe9829531c3a66dd.png')",
    ZohoCRMAPI: "url('https://images.zapier.com/storage/services/58719c2f59576a993b6c6855e0f585df.128x128.png')",
};
const LOGO_SIZES = [16, 32, 64, 128];
const logoSize = (size) => {
    return (LOGO_SIZES.find(value => value > size) || LOGO_SIZES[LOGO_SIZES.length - 1]);
};
const stripVersion = (key) => {
    key = key || '';
    return key.split('@')[0];
};
const LogoImage = ({ app, backgroundType = 'clear', border = false, borderPadding = 10, borderRadius = 20, size = 128, }) => {
    const appUnversioned = stripVersion(app);
    const imageSize = logoSize(size);
    const sizeXsize = `${imageSize}x${imageSize}`;
    const sizeWithPx = `${size}px`;
    const adjustedSizeWithPx = `${border ? size + borderPadding * 2 : size}px`;
    const styles = Object.assign({ backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', display: 'inline-block', verticalAlign: 'middle', backgroundSize: `${sizeWithPx} ${sizeWithPx}`, minWidth: adjustedSizeWithPx, width: adjustedSizeWithPx, height: adjustedSizeWithPx, backgroundImage: API_IMAGES[appUnversioned], backgroundColor: backgroundType === 'white' ? theme_1.Colors.white : 'transparent' }, (border
        ? {
            border: `1px solid ${theme_1.Colors.theme.secondary.border}`,
            borderRadius,
        }
        : {}));
    const classes = [
        `PlaceholderAPI${sizeXsize}`,
        `${appUnversioned}${sizeXsize}`,
    ];
    return (core_1.jsx(core_1.ClassNames, null, ({ css, cx }) => core_1.jsx("div", { className: cx(css(styles), classes) })));
};
exports.default = LogoImage;
